import $ from 'jquery';
import Backbone from 'backbone';
import ClientConfig from 'debug/client-config';
import Controller from 'controller';
import Dates from 'lib/dates';
import Monitor from 'lib/monitor';
import SessionStatus from 'network/session-status';
import PopOver from 'views/lib/pop-over';
import trackQuickloadEvent from 'debug/trackQuickloadEvent';
import Util from 'lib/util';
import WindowSize from 'lib/window-size';
import templates from 'views/internal/templates';
import logError from 'debug/log-error';
import 'debug/client-version-header';

// Extend jQuery with the format and formatHtml methods
import 'lib/jquery-localize';

let elem = null;
let firstTime = true;

function initClient() {
  appendElem();

  if (!firstTime) {
    Backbone.history.start({ pushState: true });
    return;
  }

  setInterval(() => {
    Dates.update('#classic-body');
    Dates.trigger('renderInterval');
  }, 10 * 1000);

  SessionStatus.start();
  Monitor.init();
  Controller.start().then(() => {
    Backbone.history.start({ pushState: true });
  });
  WindowSize.ensureRun();

  QuickLoad.onRemove((preloadObj) => {
    if (!preloadObj.used) {
      trackQuickloadEvent('quickload unused', preloadObj.url);
    }
  });

  firstTime = false;
}

export function bootstrap() {
  return Promise.resolve();
}

export function mount() {
  return Promise.resolve().then(() => initClient());
}

export function unmount() {
  return Promise.resolve().then(() => Backbone.history.stop());
}

export const timeouts = {
  bootstrap: { millis: 5000 },
  mount: { millis: 5000 },
  unmount: { millis: 5000 },
  unload: { millis: 5000 },
};

export function setElem(el) {
  elem = el;
}

export function appendElem() {
  if (document.getElementById('classic')) {
    return;
  }

  const classicContainer = document.getElementById('classic-body');
  classicContainer.appendChild(elem);
  // make sure we're not hiding this container anymore (see #removeElem)
  classicContainer.classList.remove('hideContainer');
}

export function removeElem() {
  if (!elem) {
    return;
  }

  elem.remove();

  // hide the container so that it's 100% height no longer negatively
  // impacts react-beautiful-dnd's window.scrollTo() use
  document.getElementById('classic-body').classList.add('hideContainer');
}



// WEBPACK FOOTER //
// ./app/scripts/singlespa/apps/classic.js